import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import {
  CheckboxValue,
  RedoCheckbox,
} from "@redotech/arbiter/checkbox/redo-checkbox";
import { RedoCollapseSubsection } from "@redotech/arbiter/collapse/redo-collapse-section";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextareaInputField } from "@redotech/arbiter/input/redo-textarea-input-field";
import { Text } from "@redotech/arbiter/text";
import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { memo, useState } from "react";
import {
  GorgiasImportType,
  useGorgiasImport,
} from "../../gorgias-import/use-gorgias-import";

export const GorgiasFaqsTab = memo(function GorgiasFaqsTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const [createFaqPage, setCreateFaqPage] = useState<CheckboxValue>(true);
  const [publishContent, setPublishContent] = useState<CheckboxValue>(false);

  const { jsonText, setJsonText, loading, handleImport } = useGorgiasImport({
    teamId,
    importType: GorgiasImportType.FAQS,
  });

  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" textColor="secondary">
        Paste the JSON response from the Gorgias FAQ/Help Center API endpoint.
        Categories will be imported as FAQ collections and articles as FAQ
        articles with their SEO metadata preserved.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To add this import:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>
              • Go to Gorgias and open your developer tools (right click,
              inspect)
            </li>
            <li>• Go to the network tab</li>
            <li>• Search for "articles?"</li>
            <li>
              • Open the Gorgias help center tab where they keep their FAQs
            </li>
            <li>
              • There should be a few network requests that pop up. There should
              also be a "size" column. Click on the network request with the
              biggest size
            </li>
            <li>
              • Go to the response tab in that request and copy and paste the
              entire response into this input
            </li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <RedoTextareaInputField
        disabled={loading}
        label="Gorgias FAQ JSON"
        placeholder="Paste Gorgias FAQ JSON here (the help center category tree response)"
        setValue={setJsonText}
        value={jsonText}
      />
      <Flex dir="column" gap="sm">
        <Text fontSize="sm" fontWeight="medium" textColor="secondary">
          Options
        </Text>
        <RedoCheckbox
          label="Create FAQ page"
          setValue={setCreateFaqPage}
          value={createFaqPage}
        />
        <RedoCheckbox
          label="Publish imported content"
          setValue={setPublishContent}
          value={publishContent}
        />
      </Flex>
      <div>
        <RedoButton
          disabled={!jsonText.trim() || loading}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={() =>
            handleImport({
              jsonText,
              createFaqPage: createFaqPage === true,
              publishImportedContent: publishContent === true,
            })
          }
          pending={loading}
          size="md"
          text="Import FAQs"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
